import { render, staticRenderFns } from "./byFourIndex.vue?vue&type=template&id=d46389aa&scoped=true"
import script from "./byFourIndex.vue?vue&type=script&lang=js"
export * from "./byFourIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46389aa",
  null
  
)

export default component.exports